import { useLocation } from '@reach/router'

export const useCurrentUrl = (): string => {
  const location = useLocation()
  return `${location.origin}${location.pathname}`
}
